import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from '@etop/web/core/app.service';
import { CommonUsecase } from 'apps/shared/src/usecases/common.usecase.service';
import {UtilService} from 'apps/core/src/services/util.service';
import { LocationService } from '@etop/state/location';
import { AuthenticateStore, ConfigService } from '@etop/core';
import { CallingState, WebphoneQuery } from '@etop/state/shop/webphone';

@Component({
  selector: 'etelecom-cs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loadConfig = true;
  delayPassed = false;
  completedView = false;

  showWebphonePopup = false;

  callState$ = this.webphoneQuery.select(state => state.callState);
  isRegistered$ = this.webphoneQuery.select('isPortsipRegistered');
  enableCallFunc$ = this.webphoneQuery.select('enableCallFunc');
  callFunc = false;

  constructor(
    private appService: AppService,
    private commonUsecase: CommonUsecase,
    private utilService: UtilService,
    private locationService: LocationService,
    private config: ConfigService,
    private auth: AuthenticateStore,
    private webphoneQuery: WebphoneQuery,
    private cdr: ChangeDetectorRef,
  )
  {
    this.utilService.checkMobileVersion();
    this.utilService.checkMediumVersion();
  }


  ngOnInit() {
    
    setTimeout(() => this.delayPassed = true, 1000);
    this.appService.bootstrap()
      .then(() => this.commonUsecase.checkAuthorization(true))
      .then(() => this.loadConfig = false)
      .then(() => {
        if (this.auth?.snapshot?.token) {
          this.locationService.initLocations().then();
        }
      })
      .catch(err => debug.log('Bootstrap failed', err));

      this.callState$.subscribe(state => {
        if (state == CallingState.callingIn) {
          this.showWebphonePopup = true;
        }
      })

      this.enableCallFunc$.subscribe(state => {
        this.callFunc = state
        this.cdr.detectChanges()
      })
  }

  isLogined() {
    return this.auth?.snapshot?.token;
  }

  getAssets() {
    return this.config.get('assets')
  }

  toggleWebphone() {
    this.showWebphonePopup = !this.showWebphonePopup;
  }

  onCallFunc() {
    return this.callFunc || this.auth.snapshot.enable_call;
  }

  closeWebphone() {
    // this.webphone.hide();
    this.showWebphonePopup = false;
  }

}
